import { PasswordSchema } from '../../../utils/commonSchema';

export const schema = {
  currentPassword: PasswordSchema.required(),
  newPassword: PasswordSchema.required(),
  verifyNewPassword: PasswordSchema.required(),
};
